// COM-HUBS (2026-08-21): Clientes — Empresas + Contatos.
// Mantém o path `/comercial/clientes` (Empresas era quem morava aí), então
// links antigos e o atalho da Visão Geral continuam certos.
//
// 2026-09-03: entrou 🔑 Portais — onde a Hydrodata está cadastrada como
// FORNECEDORA. Mora aqui, e não no hub de Licitações, porque 6 dos 9 cadastros
// são portal de um cliente específico (Solví, Copasa, Samarco, Aegea, Auren):
// é a contraparte da ficha do cliente, não uma etapa do edital. Ver a aba e
// ver a senha são permissões diferentes: quem revela está numa LISTA DE PESSOAS
// (`comercial.portais_acesso`), editada na própria aba, e não numa permissão de
// perfil — liberar uma pessoa não pode significar liberar o cargo inteiro.
import HubAbas, { HubTab } from '../../components/HubAbas';
import ComercialClientes from '../ComercialClientes';
import ComercialContatos from '../ComercialContatos';
import PainelPortais from '../comercial-portais/PainelPortais';

const TABS: HubTab[] = [
  { key: 'empresas', label: '🏢 Empresas', perm: 'comercial.empresas.ver', render: () => <ComercialClientes /> },
  { key: 'contatos', label: '👤 Contatos', perm: 'comercial.contatos.ver', render: () => <ComercialContatos /> },
  { key: 'portais',  label: '🔑 Portais',  perm: 'comercial.portais.ver',  render: () => <PainelPortais /> },
];

export default function ComercialClientesHub() {
  return <HubAbas tabs={TABS} />;
}
